const findLinks = () => [].slice.call(document.querySelectorAll('[data-event]'));
const getEvent = (el) => el.getAttribute('data-event') ? JSON.parse(el.getAttribute('data-event')) : null;
const triggerItem = (item) => {
    const gaEvent = getEvent(item);
    if (gaEvent && gaEvent.event === 'select_item') {
        localStorage.setItem('list_name', gaEvent.ecommerce.item_list_name);
        localStorage.setItem('list_index', gaEvent.ecommerce.items[0].index);
    }
    if (window.dataLayer && gaEvent)
        window.dataLayer.push(gaEvent);
};
const triggerListTag = (lists) => {
    Object.keys(lists).map((listName) => {
        return {
            item_list_name: listName,
            items: lists[listName]
        };
    }).forEach((list) => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'view_item_list',
                ecommerce: list
            });
        }
    });
};
const triggerProductItem = (item) => {
    const gaEvent = getEvent(item);
    if (gaEvent)
        gaEvent.event = 'view_item_list';
    if (window.dataLayer && gaEvent)
        window.dataLayer.push(gaEvent);
};
const updatePageEvents = () => {
    if (typeof document === 'undefined')
        return;
    findLinks().forEach(item => {
        if (!item.hasTagAttached) {
            const eventName = item.tagName.toUpperCase() === 'FORM' ? 'submit' : 'click';
            item.addEventListener(eventName, (e) => {
                triggerItem(item);
            });
            item.hasTagAttached = true;
        }
    });
};
const lastTags = {};
const openPopin = (name, store) => {
    triggerPopin(name, true);
    lastTags[store] = name;
};
const closePopin = (store) => {
    if (lastTags[store]) {
        triggerPopin(lastTags[store], false);
        lastTags[store] = null;
    }
};
const triggerPopin = (name, state) => {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'view_popin',
            popin_name: name,
            popin_state: state ? 'open' : 'close'
        });
    }
};
const tag = { updatePageEvents, triggerItem, openPopin, closePopin, triggerProductItem, getEvent, triggerListTag };
export default tag;
